import React from 'react'
import { Link } from 'react-router-dom'
import HeroBg from '../ui/HeroBg'

/**
 * HeroSection — Single-column hero with SVG background, headline,
 * subheadline, CTA buttons, and trust badges strip.
 */
export default function HeroSection() {
  return (
    <section
      className="hero section-hero"
      id="hero"
      aria-label="Hero"
      style={{ overflow: 'hidden' }}
    >
      {/* Looping video background */}
      <HeroBg />

      <div className="container hero-grid">

        {/* Center — Content */}
        <div className="hero-content" data-animate="fade-up" style={{ position: 'relative', zIndex: 4 }}>
          <h1 className="hero-headline">
            Building the Foundation<br />
            for AI-Native Organizations
          </h1>

          <p className="hero-subheadline" style={{ marginBottom: 0 }}>
            <span className="hero-highlight">
              AugmentAppz helps enterprises move from traditional software to AI-native execution,
            </span>
          </p>
          <p className="hero-subheadline" style={{ marginTop: 0, opacity: 0.85 }}>
            by combining platform capability and transformation expertise to build intelligent
            systems at production scale.
          </p>

          <div className="hero-actions">
            <a
              href="https://studio.qraptor.ai/auth/realms/qraptor/protocol/openid-connect/auth?response_type=code&client_id=qraptor-gateway&scope=openid%20profile%20email&state=oIHXu5lxUKUS9wqKFAyh7PBgyB9rSulquyMGd1pIN6g%3D&redirect_uri=https://studio.qraptor.ai/login/oauth2/code/keycloak&nonce=pT864Gld8PM7yZdbCM_rocra-pLk2k3A5SSRU6LwpRY"
              className="btn btn-primary btn-lg"
              target="_blank"
              rel="noopener noreferrer"
            >
              Explore the Platform
              <svg className="btn-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
            <Link
              to="/transform"
              className="btn btn-outline btn-lg"
            >
              Start Your AI Transformation
            </Link>
          </div>

          {/* Trust badges strip */}
          <div className="hero-trust-strip">
            <div className="hero-trust-item">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 2L6.5 5v4.5c0 5 2.5 8.5 5.5 10.5 3-2 5.5-5.5 5.5-10.5V5L12 2z" stroke="#7C3AED" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M9.5 7.5h5l-1.5 3h2.5L10 17l1.5-4.5H9L9.5 7.5z" fill="#7C3AED" opacity="0.85" />
              </svg>
              <span>AI-Native Platform</span>
            </div>
            <div className="hero-trust-divider" aria-hidden="true" />
            <div className="hero-trust-item">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="#7C3AED" strokeWidth="1.5" />
                <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="#7C3AED" strokeWidth="1.5" />
                <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="#7C3AED" strokeWidth="1.5" />
                <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="#7C3AED" strokeWidth="1.5" />
              </svg>
              <span>Enterprise Transformation</span>
            </div>
            <div className="hero-trust-divider" aria-hidden="true" />
            <div className="hero-trust-item">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M3 20L7 13l4 4 3-6 4 5h3" stroke="#7C3AED" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M21 20H3V4" stroke="#7C3AED" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>Production-Scale Systems</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
